/*
* jquery-match-height 0.7.0 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,i=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),n=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-i(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(n-a))<=o?r[r.length-1]=s.add(e):r.push(e),n=a}),r},n=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=n(e);if(o.remove){var i=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(i)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.0",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=i,r._parseOptions=n,r._apply=function(e,o){var s=n(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),d=h.parents().filter(":hidden");return d.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),d.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),n=0;if(s.target)n=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),i=e.css("display");"inline-block"!==i&&"flex"!==i&&"inline-flex"!==i&&(i="block");var a={
display:i};a[s.property]="",e.css(a),e.outerHeight(!1)>n&&(n=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=i(e.css("border-top-width"))+i(e.css("border-bottom-width")),o+=i(e.css("padding-top"))+i(e.css("padding-bottom"))),e.css(s.property,n-o+"px"))})}),d.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),i=o.attr("data-mh")||o.attr("data-match-height");i in e?e[i]=e[i].add(o):e[i]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(i,a){if(a&&"resize"===a.type){var n=t(window).width();if(n===e)return;e=n;
}i?-1===o&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi),t(window).bind("load",function(t){r._update(!1,t)}),t(window).bind("resize orientationchange",function(t){r._update(!0,t)})});
//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function($) {
	var e = window, a = 'inner';
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	$.fn.viewport = function(options) {
		if (this.get(0) != window)
			return { width: this.outerWidth(), height: this.outerHeight() };
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	$.fn.viewportWidth = function(options) {
		if (this.get(0) != window)
			return this.outerWidth();
		return e[ a+'Width' ];
	};

	$.fn.viewportHeight = function(options) {
		if (this.get(0) != window)
			return this.outerHeight();
		return e[ a+'Height' ];
	};

	$.fn.filterByData = function(prop, val) {
		this.filter(
			function() { return $(this).data(prop)==val; }
			);
	};
})(jQuery);
jQuery(document).ready(function($) {
	// Global vars
	var windowWidth = 0,
	windowHeight = 0,
	scrollTop = 0,
	loading = true,
	$self, 
	$this,
	$window = $(window),	
	$document = $(document),	
	body = $('body'),
	header = $('.header'),
	main = $('.main'),
	footer = $('.footer');

	/*====================================
	Window Events
	====================================*/

	$window.resize(function(e) {
		//Causes resize not to fire if the windows haven't actually changed (great for IE8)
		// if (windowWidth != $window.viewportWidth() || windowHeight != $window.viewportHeight()) {
			windowWidth = $window.viewportWidth();
			windowHeight = $window.viewportHeight();

			//Code goes here
			main.css('min-height', windowHeight - ( header.outerHeight(true) + footer.outerHeight(true) ) );
			
		// }
	}).resize();

	/*====================================
	Document Events
	====================================*/

	$document.scroll(function(e) {
		scrollTop = $document.scrollTop();
		if (scrollTop > 100) {
			//forces browser to chill out for a moment if the page just loaded
			setTimeout(function() {
				body.addClass('scrolled');
			}, loading ? 500 : 0);
		} else {
			body.removeClass('scrolled');
		}
		// console.log(scrollTop);
	});

	//stops the browser loading delay 
	setTimeout(function() {
		loading = false;
	}, 500);

$('.matchTitleHeight').matchHeight();
$('.matchHeight').matchHeight();

$('.cycle-slideshow').on('cycle-initialized', function(e) {
	console.log('init');
});

});//End doc.ready

// $(window).on('load', function (e) {
// 	$(window).resize();
// });